import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden">
      <Header />
      <main className="pt-24 lg:pt-28">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
